import React, {useContext,Fragment,useEffect} from 'react';
import Product from '../Components/Product/Product';
import {ConfigurationContext} from '../Context/Configuration';
import MainBanner from '../Components/MainBanner/MainBanner';

const Smoulder=(props)=>{
	
	const [config, update]=useContext(ConfigurationContext);

	useEffect(() => {
		window.scrollTo(0, 0)
	  }, [])

	return(
		<React.Fragment>
		<MainBanner 
			background_left="/preseedherbicide/images/smoulder_head.png"
			background_left_alt="Homegrown to get the toughest prarie weeds"
			background_right=""
		/>
			
		<Product details={config.products.smoulder}/>
		</React.Fragment>
	);
}

export default Smoulder;

